import { Menu } from 'antd';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { MdDashboard } from 'react-icons/md';
import { FaUsers, FaChalkboardTeacher, FaVideo } from 'react-icons/fa';
import { PiExam, PiNotePencilLight, PiStudentBold } from 'react-icons/pi';
import UilEllipsisV from '@iconscout/react-unicons/icons/uil-ellipsis-v';
import propTypes from 'prop-types';
import { GiTeacher } from 'react-icons/gi';
import { changeDirectionMode, changeLayoutMode, changeMenuMode } from '../redux/themeLayout/actionCreator';
import Cookies from 'js-cookie';
import { VscReferences } from 'react-icons/vsc';
import { CiDiscount1 } from 'react-icons/ci';
import { SiBookstack } from 'react-icons/si';
import { IoBookSharp } from 'react-icons/io5';
import { GiNotebook } from 'react-icons/gi';

function MenuItems({ toggleCollapsed }) {
  const { t } = useTranslation();

  const [menuItems, setMenuItems] = useState([]);

  // Getting userType from Cookie
  const userType = Cookies.get('userType');

  function getItem(label, key, icon, children, type) {
    return {
      key,
      icon,
      children,
      label,
      type,
    };
  }

  const { topMenu } = useSelector((state) => {
    return {
      topMenu: state.ChangeLayoutMode.topMenu,
    };
  });

  const dispatch = useDispatch();

  const path = '/admin';

  const pathName = window.location.pathname;
  const pathArray = pathName.split(path);
  const mainPath = pathArray[1];
  const mainPathSplit = mainPath.split('/');

  const [openKeys, setOpenKeys] = React.useState(
    !topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'dashboard'}`] : [],
  );

  const onOpenChange = (keys) => {
    setOpenKeys(keys[keys.length - 1] !== 'recharts' ? [keys.length && keys[keys.length - 1]] : keys);
  };

  const onClick = (item) => {
    if (item.keyPath.length === 1) setOpenKeys([]);
  };

  const changeLayout = (mode) => {
    dispatch(changeLayoutMode(mode));
  };
  const changeNavbar = (topMode) => {
    const html = document.querySelector('html');
    if (topMode) {
      html.classList.add('hexadash-topmenu');
    } else {
      html.classList.remove('hexadash-topmenu');
    }
    dispatch(changeMenuMode(topMode));
  };

  const changeLayoutDirection = (rtlMode) => {
    if (rtlMode) {
      const html = document.querySelector('html');
      html.setAttribute('dir', 'rtl');
    } else {
      const html = document.querySelector('html');
      html.setAttribute('dir', 'ltr');
    }
    dispatch(changeDirectionMode(rtlMode));
  };

  const darkmodeActivated = () => {
    document.body.classList.add('dark');
  };

  const darkmodeDiactivated = () => {
    document.body.classList.remove('dark');
  };

  const items = [
    getItem(
      <NavLink onClick={toggleCollapsed} to={`${path}`}>
        {t('Dashboard')}
      </NavLink>,
      'dashboard',
      !topMenu && (
        <NavLink className="menuItem-iocn" to={`${path}`}>
          <MdDashboard />
        </NavLink>
      ),
    ),
    getItem(
      <NavLink onClick={toggleCollapsed} to={`${path}/role`}>
        {t('Role Management')}
      </NavLink>,
      'role',
      !topMenu && (
        <NavLink className="menuItem-iocn" to={`${path}/role`}>
          <FaUsers />
        </NavLink>
      ),
    ),
    getItem(
      <NavLink onClick={toggleCollapsed} to={`${path}/teacher`}>
        {t('Teacher Management')}
      </NavLink>,
      'Teacher Management',
      !topMenu && (
        <NavLink className="menuItem-iocn" to={`${path}/teacher`}>
          <FaChalkboardTeacher />
        </NavLink>
      ),
    ),
    getItem(
      <NavLink onClick={toggleCollapsed} to={`${path}/student`}>
        {t('Student Management')}
      </NavLink>,
      'student',
      !topMenu && (
        <NavLink className="menuItem-iocn" to={`${path}/student`}>
          <PiStudentBold />
        </NavLink>
      ),
    ),
    // getItem(
    //   <NavLink onClick={toggleCollapsed} to={`${path}/user`}>
    //     {t('User Management')}
    //   </NavLink>,
    //   'user',
    //   !topMenu && (
    //     <NavLink className="menuItem-iocn" to={`${path}/user`}>
    //       <PiStudentBold />
    //     </NavLink>
    //   ),
    // ),
    getItem(t('Content Management'), 'contentManagement', <SiBookstack />, [
      getItem(
        <NavLink onClick={toggleCollapsed} to={`${path}/front-course`}>
          {t('Front-course')}
        </NavLink>,
        'front-course',
      ),
      getItem(
        <NavLink onClick={toggleCollapsed} to={`${path}/course`}>
          {t('Course')}
        </NavLink>,
        'course',
      ),
      getItem(
        <NavLink onClick={toggleCollapsed} to={`${path}/batch`}>
          {t('Batch')}
        </NavLink>,
        'batch',
      ),
      getItem(
        <NavLink onClick={toggleCollapsed} to={`${path}/plans`}>
          {t('Plans')}
        </NavLink>,
        'plans',
      ),
      // getItem(
      //   <NavLink onClick={toggleCollapsed} to={`${path}/subject`}>
      //     {t('subject')}
      //   </NavLink>,
      //   'subject',
      // ),
      getItem(
        <NavLink onClick={toggleCollapsed} to={`${path}/question-upload`}>
          {t('Question-upload')}
        </NavLink>,
        'question-upload',
      ),
      getItem(
        <NavLink onClick={toggleCollapsed} to={`${path}/subject-add-details`}>
          {t('Subject-details')}
        </NavLink>,
        'subject-details',
      ),
      getItem(
        <NavLink onClick={toggleCollapsed} to={`${path}/class`}>
          {t('Class')}
        </NavLink>,
        'class',
      ),
    ]),
    getItem(
      t('Practice Management'), // This is the label for the submenu
      'Practice', // This is the key for the submenu
      <PiNotePencilLight />,
      [
        // These are the nested items within the submenu
        getItem(
          <NavLink
            onClick={toggleCollapsed}
            to={`${path}/practice-management`}
            className={'flex items-center justify-start gap-3 w-full'}
            style={{ paddingLeft: '0px' }}
          >
            {t('Custom Practice')}
          </NavLink>,
          'Practice-Management',
        ),
        getItem(
          <NavLink
            onClick={toggleCollapsed}
            to={`${path}/practice-details`}
            className={'flex items-center justify-start gap-3 w-full'}
            style={{ paddingLeft: '0px' }}
          >
            {t('Practice-Details')}
          </NavLink>,
          'practice-details',
        ),
        getItem(
          <NavLink
            onClick={toggleCollapsed}
            to={`${path}/reported-questions`}
            className={'flex items-center justify-start gap-3 w-full'}
            style={{ paddingLeft: '0px' }}
          >
            {t('Report-Questions')}
          </NavLink>,
          'Report-Questions',
        ),
      ],
    ),
    getItem(
      t('Test Management'),
      'test',
      // <FaClipboardList />,
      <PiExam />,
      [
        // getItem(
        //   <NavLink
        //     onClick={toggleCollapsed}
        //     to={`${path}/test`}
        //     className={'flex items-center justify-start gap-3 w-full'}
        //     style={{ paddingLeft: '0px' }}
        //   >
        //     {t('Create Test')}
        //   </NavLink>,
        //   'Test-create',
        // ),
        getItem(
          <NavLink
            onClick={toggleCollapsed}
            to={`${path}/test/details`}
            className={'flex items-center justify-start gap-3 w-full'}
            style={{ paddingLeft: '0px' }}
          >
            {t('Test Details')}
          </NavLink>,
          'Test-Details',
        ),
      ],
    ),
    getItem(
      t('Referral Management'), // This is the label for the submenu
      'referralManager', // This is the key for the submenu
      // <FaClipboardList />, // The icon for the submenu
      <FaUsers />,

      [
        // These are the nested items within the submenu
        getItem(
          <NavLink onClick={toggleCollapsed} to={`${path}/refer`}>
            {t('List')}
          </NavLink>,
          'refer',
        ),
        getItem(
          <NavLink onClick={toggleCollapsed} to={`${path}/transactionHistory`}>
            {t('Referral History')}
          </NavLink>,
          'transactionHistory',
        ),
      ],
    ),
    // getItem(
    //   <NavLink onClick={toggleCollapsed} to={`${path}/discount`}>
    //     {t('Discount Management')}
    //   </NavLink>,
    //   'discount',
    //   !topMenu && (
    //     <NavLink className="menuItem-iocn" to={`${path}/discount`}>
    //       <CiDiscount1 />
    //     </NavLink>
    //   ),
    // ),
    getItem(
      t('Discount Management'), // This is the label for the submenu
      'discountManagement', // This is the key for the submenu
      // <FaClipboardList />, // The icon for the submenu
      <CiDiscount1 />,
      [
        getItem(
          <NavLink onClick={toggleCollapsed} to={`${path}/course-discounts`}>
            {t('Course Section')}
          </NavLink>,
          'course-discounts',
        ),
        getItem(
          <NavLink onClick={toggleCollapsed} to={`${path}/marketplace-discounts`}>
            {t('Marketplace')}
          </NavLink>,
          'marketplace-discounts',
        ),
      ],
    ),
    getItem(
      t('Notification Management'), // This is the label for the submenu
      'notificationManagement', // This is the key for the submenu
      // <FaClipboardList />, // The icon for the submenu
      <FaChalkboardTeacher />,
      [
        getItem(
          <NavLink onClick={toggleCollapsed} to={`${path}/notification`}>
            {t('Broadcast')}
          </NavLink>,
          'notification',
        ),
        getItem(
          <NavLink onClick={toggleCollapsed} to={`${path}/paid`}>
            {t('Subscribed User')}
          </NavLink>,
          'paid',
        ),
        getItem(
          <NavLink onClick={toggleCollapsed} to={`${path}/free`}>
            {t('Non-Subscribed User')}
          </NavLink>,
          'free',
        ),
        getItem(
          <NavLink onClick={toggleCollapsed} to={`${path}/teacher-notification`}>
            {t('Educator')}
          </NavLink>,
          'teacher-notification',
        ),
      ],
    ),
    getItem(
      t('Marketplace Management'), // This is the label for the submenu
      'Marketplace Management', // This is the key for the submenu
      <PiNotePencilLight />,
      [
        getItem(
          <NavLink
            onClick={toggleCollapsed}
            to={`${path}/marketplace-management`}
            className={'flex items-center justify-start gap-3 w-full'}
            style={{ paddingLeft: '0px' }}
          >
            {t('MarketPlace')}
          </NavLink>,
          'MarketPlace',
        ),
      ],
    ),
    getItem(
      t('Daily-challenge Management'), // This is the label for the submenu
      'Daily-challenge Management', // This is the key for the submenu
      <PiNotePencilLight />,
      [
        getItem(
          <NavLink
            onClick={toggleCollapsed}
            to={`${path}/daily-challenge`}
            className={'flex items-center justify-start gap-3 w-full'}
            style={{ paddingLeft: '0px' }}
          >
            {t('Daily-Challenge')}
          </NavLink>,
          'Daily-Challenge',
        ),
      ],
    ),
    getItem(
      t('Lectures Management'), // This is the label for the submenu
      'lecturesManagement', // This is the key for the submenu
      <FaVideo />,
      [
        getItem(
          <NavLink onClick={toggleCollapsed} to={`${path}/lectures-management`}>
            {t('Scheduled Lectures')}
          </NavLink>,
          'scheduledLectures',
        ),
        getItem(
          <NavLink onClick={toggleCollapsed} to={`${path}/video-library`}>
            {t('Video Library')}
          </NavLink>,
          'videoLibrary',
        ),
      ],
    ),
  ];

  const teacherItems = [
    getItem(
      <NavLink onClick={toggleCollapsed} to={`${path}`}>
        {t('dashboard')}
      </NavLink>,
      'dashboard',
      !topMenu && (
        <NavLink className="menuItem-iocn" to={`${path}`}>
          <MdDashboard />
        </NavLink>
      ),
    ),
    getItem(
      t('Practice Management'), // This is the label for the submenu
      'Practice', // This is the key for the submenu
      <PiNotePencilLight />,
      [
        getItem(
          <NavLink
            onClick={toggleCollapsed}
            to={`${path}/reported-questions`}
            className={'flex items-center justify-start gap-3 w-full'}
            style={{ paddingLeft: '0px' }}
          >
            {t('Report-Questions')}
          </NavLink>,
          'Report-Questions',
        ),
      ],
    ),
    getItem(
      t('Test Management'),
      'test',
      // <FaClipboardList />,
      <PiExam />,
      [
        getItem(
          <NavLink
            onClick={toggleCollapsed}
            to={`${path}/test`}
            className={'flex items-center justify-start gap-3 w-full'}
            style={{ paddingLeft: '0px' }}
          >
            {t('Create Test')}
          </NavLink>,
          'Test-create',
        ),
        getItem(
          <NavLink
            onClick={toggleCollapsed}
            to={`${path}/test/teacher/details`}
            className={'flex items-center justify-start gap-3 w-full'}
            style={{ paddingLeft: '0px' }}
          >
            {t('Test Details')}
          </NavLink>,
          'Test-Details',
        ),
      ],
    ),
    getItem(
      t('Lecture management'), // This is the label for the submenu
      'videoLectureManagement', // This is the key for the submenu
      <FaVideo />, // The icon for the submenu
      [
        // These are the nested items within the submenu
        getItem(
          <NavLink onClick={toggleCollapsed} to={`${path}/assigned-courses-and-subjects`}>
            {t('Assigned Courses')}
          </NavLink>,
          'assignedCourses',
        ),
        getItem(
          <NavLink onClick={toggleCollapsed} to={`${path}/schedule-new-lecture`}>
            {t('Schedule new lecture')}
          </NavLink>,
          'scheduleNewLectures',
        ),
        getItem(
          <NavLink onClick={toggleCollapsed} to={`${path}/scheduled-lectures`}>
            {t('Scheduled lectures')}
          </NavLink>,
          'scheduledLectures',
        ),
        // getItem(
        //   <NavLink onClick={toggleCollapsed} to={`${path}/Schedule-leacture-form`}>
        //     {t('Schedule-leacture-form')}
        //   </NavLink>,
        //   'Schedule-leacture-form',
        // ),
        getItem(
          <NavLink onClick={toggleCollapsed} to={`${path}/schedule-live-lecture`}>
            {t('Schedule live session')}
          </NavLink>,
          'scheduleLiveLectures',
        ),
        getItem(
          <NavLink onClick={toggleCollapsed} to={`${path}/scheduled-sessions`}>
            {t('Scheduled sessions')}
          </NavLink>,
          'scheduledSessions',
        ),
      ],
    ),
    getItem(t('Notes'), 'notes', <GiNotebook />, [
      getItem(
        <NavLink onClick={toggleCollapsed} to={`${path}/notes`}>
          {t('Notes')}
        </NavLink>,
        'notesKey',
      ),
    ]),
    // getItem(t('E-library'), 'elibrary', <IoBookSharp />, [
    //   getItem(
    //     <NavLink onClick={toggleCollapsed} to={`${path}/elibrary`}>
    //       {t('E-library')}
    //     </NavLink>,
    //     'elibraryKey',
    //   ),
    // ]),
    getItem(
      t('Daily-challenge Management'), // This is the label for the submenu
      'Daily-challenge Management', // This is the key for the submenu
      <PiNotePencilLight />,
      [
        getItem(
          <NavLink
            onClick={toggleCollapsed}
            to={`${path}/daily-challenge`}
            className={'flex items-center justify-start gap-3 w-full'}
            style={{ paddingLeft: '0px' }}
          >
            {t('Daily-Challenge')}
          </NavLink>,
          'Daily-Challenge',
        ),
      ],
    ),
    // <NavLink
    //   onClick={toggleCollapsed}
    //   to={`${path}/userinfo`}
    //   className={'flex items-center justify-start gap-3 w-full'}
    //   style={{ paddingLeft: '0px' }}
    // >
    //   {t('Teacher')}
    // </NavLink>,
    // 'userinfo',
    // !topMenu && (
    //   <NavLink className="menuItem-iocn" to={`${path}`}>
    //     <GiTeacher />
    //   </NavLink>
    // ),
    getItem(
      <NavLink
        onClick={toggleCollapsed}
        to={`${path}/referteacher`}
        className={'flex items-center justify-start gap-3 w-full'}
        style={{ paddingLeft: '0px' }}
      >
        {t('Teacher Refer History')}
      </NavLink>,
      'referteacher',
      !topMenu && (
        <NavLink className="menuItem-iocn" to={`${path}`}>
          <VscReferences />
        </NavLink>
      ),
    ),
  ];

  const managementItems = [
    getItem(
      <NavLink onClick={toggleCollapsed} to={`${path}`}>
        {t('dashboard')}
      </NavLink>,
      'dashboard',
      !topMenu && (
        <NavLink className="menuItem-iocn" to={`${path}`}>
          <MdDashboard />
        </NavLink>
      ),
    ),
    getItem(t('Content Management'), 'contentManagement', <SiBookstack />, [
      getItem(
        <NavLink onClick={toggleCollapsed} to={`${path}/content-management`}>
          {t('subject')}
        </NavLink>,
        'subject',
      ),
      // getItem(
      //   <NavLink onClick={toggleCollapsed} to={`${path}/class`}>
      //     {t('class')}
      //   </NavLink>,
      //   'class',
      // ),
    ]),
  ];

  useEffect(() => {
    if (userType == 2) {
      setMenuItems(teacherItems);
    } else if (userType == 4) {
      setMenuItems(managementItems);
    } else {
      setMenuItems(items);
    }
  }, [userType]);

  return (
    <Menu
      onOpenChange={onOpenChange}
      onClick={onClick}
      mode={!topMenu || window.innerWidth <= 991 ? 'inline' : 'horizontal'}
      defaultSelectedKeys={
        !topMenu
          ? [
              `${
                mainPathSplit.length === 1 ? 'home' : mainPathSplit.length === 2 ? mainPathSplit[1] : mainPathSplit[2]
              }`,
            ]
          : []
      }
      defaultOpenKeys={!topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'dashboard'}`] : []}
      overflowedIndicator={<UilEllipsisV />}
      openKeys={openKeys}
      items={menuItems}
    />
  );
}

MenuItems.propTypes = {
  toggleCollapsed: propTypes.func,
};

export default MenuItems;
